module.exports = __webpack_public_path__ + "images/pages/fifth_anniversary_lp/campaign-mvBgImg_web_efa2a43eae62afe69d9543973a3753e2.png";